import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  IconEdit2,
  IconDelete2,
  ClickShare,
  TickGreen,
  CrossRed,
  FilterIcon2,
  IconCross,
  IconSort,
  IconStatus,
  IconError,
} from "../../../../icons/Icons";
import { Row, Col, Accordion, Button } from "react-bootstrap";
import OwnerImg from "../../../../assets/images/Account.png";
import TeamsNav from "./TeamsNav";
import Onboarding from "./Status/Onboarding";
import TeamsProcess from "./Status/AccountOnboarding";
import TeamsModule from "./Status/TeamsModule";
import { useSelector, useDispatch } from "react-redux";
import {
  updateTeamAsync,
  deleteTeamAsync,
  getTeamDetailsAsync,
  getTeamsAsync,
  getEmpTeamListAsync,
} from "../../../../reducers/user-reducers";
import TextInput from "../../../../components/FormikInputs/TextInput";
import ModalDelete from "../../../../components/ModalPopup/ModalDeletePopup";
import ModalResponse from "../../../../components/ModalPopup/ModalResponsePopup";
import { Modal } from "react-bootstrap";
import EmptyState from "../../../../components/EmptyState/EmptyState";
import { getFormatDate } from "../../../../common";
import ToasterAlertSucces from "../../../../helper/ToasterAlertSucces";
import { ErrrorMessage } from "../../../../helper/ErrorMessage";
import AdminTeam from "./Status/AdminTeam";
import UserImage from "../../../../components/UserImage/UserImage";
import getInitialsInName from "../../../../helper/GetNameInitials";
import DateTimeConverter from "../../../../components/DateTimeConverter/DateTimeConverter";
import { IconleftArrow } from "../../../../icons/Icons";
import { IconrightArrow } from "../../../../icons/Icons";
import Loader from "../../../../components/Loader/Loader";
import ToasterAlertError from "../../../../helper/ToasterAlertError";

const TeamDetails = ({
  setSelectedTeam,
  actionActivity,
  teamId,
  teamName,
  setIsTeamUpdated,
  setUserData,
}) => {
  const [isNameEditable, setIsNameEditable] = useState(false);
  const [isNameEdit, setIsNameEdit] = useState(false);
  const [updateTeamName, setUpdateTeamName] = useState(teamName);
  const [responsePopup, setResponsePopup] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [teamDetail, setteamDetail] = useState(null);
  const [activeTab, setActiveTab] = useState("Currently Onboarding");
  const dispatch = useDispatch();
  const [showProcessModal, setShowProcessModal] = useState(false);
  const [showSequenceModal, setShowSequenceModal] = useState(false);
  const [showModuleModal, setShowModuleModal] = useState(false);
  const [showModuleState, setShowModuleState] = useState();
  const [searchString, setSearchString] = useState("");
  const [loading, setLoading] = useState(true);
  // pagination code start ============================================
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page
  const [totalPages, setTotalPages] = useState(0);
  const [teamMember, setTeamMember] = useState([]);
  const indexOfLastEmployee = currentPage * itemsPerPage;
  // pagination code end ============================================
  const [originalTeamName, setOriginalTeamName] = useState("");

  const onClose = () => {
    setResponsePopup({
      show: false,
      propmt: "",
      message: "",
      records: [],
    });
  };

  const getTeams = () => {
    const reqBody = {
      searchString: encodeURIComponent(searchString),
    };
    dispatch(getEmpTeamListAsync(reqBody)).then((res) => {
      //console.log(res, "res")
      setSelectedTeam(res?.payload[0] ? res?.payload[0] : undefined);
    });
    setIsTeamUpdated(false);
  };

  const processResponse = (res, operation) => {
    let prompt = res.payload === "success" ? "Success" : "Error";
    let successMessage =
      operation === "Delete" &&
      res.payload === "success" &&
      `Team has been deleted successfully.`;
    // : "You can’t delete this team as it has some user data.";
    let message = res?.payload ? successMessage : `${operation} Failed!!`;

    setResponsePopup({
      show: true,
      propmt: prompt,
      message: message,
      records: [],
      // procesFailedError: "Delete failed",
    });
  };

  const onConfirm = () => {
    const reqBody = {
      id: teamId,
    };

    if (deleteModal) {
      dispatch(deleteTeamAsync(reqBody)).then((res) => {
        // console.log(res);
        processResponse(res, "Delete");
        if (res.payload === "success") {
          getTeams();
          setIsTeamUpdated(true);
          //setSelectedTeam(null);
        }
      });
      setDeleteModal(false);
    }
  };

  console.log(updateTeamName, "updateTeamName");
  console.log(teamName, "teamName");

  const handleNameUpdate = () => {
    if (updateTeamName) {
      const reqBody = {
        id: teamId,
        name: encodeURIComponent(updateTeamName),
      };
      dispatch(updateTeamAsync(reqBody)).then((res) => {
        if (res.payload) {
          ToasterAlertSucces(res, ErrrorMessage.UPDATE);

          dispatch(getTeamsAsync());
          setIsTeamUpdated(true);
          setSelectedTeam({ id: teamId, name: updateTeamName });
          setUpdateTeamName(updateTeamName);
        } else {
          setUpdateTeamName(teamName);
        }
      });
    }
    setIsNameEditable(false);
  };

  useEffect(() => {}, [updateTeamName]);
  const getTeamDetails = async (teamId) => {
    setLoading(true);
    await dispatch(getTeamDetailsAsync(teamId)).then((res) => {
      setteamDetail(res.payload);
      setLoading(false);
    });
  };

  useEffect(() => {
    setTotalPages(0);
    setTeamMember([]);
    // Slice the employees array based on the current page and items per page
    const indexOfFirstEmployee = indexOfLastEmployee - itemsPerPage;
    let totalPagesCount = [];
    let teamMembers = [];
    if (
      teamDetail?.currentMembers?.employees?.length > 0 &&
      activeTab === "Currently Onboarding"
    ) {
      totalPagesCount = Math.ceil(
        teamDetail?.currentMembers?.employees?.length / itemsPerPage
      );
      setTotalPages(totalPagesCount);
      teamMembers = teamDetail?.currentMembers?.employees?.slice(
        indexOfFirstEmployee,
        indexOfLastEmployee
      );
      setTeamMember(teamMembers);
    }
    // else if (teamDetail?.pendingMembers?.employees?.length > 0 && activeTab === "Pending") {
    //   totalPagesCount = Math.ceil(teamDetail?.pendingMembers?.employees?.length / itemsPerPage);
    //   setTotalPages(totalPagesCount);
    //   teamMembers = teamDetail?.pendingMembers?.employees?.slice(indexOfFirstEmployee, indexOfLastEmployee);
    //   setTeamMember(teamMembers);
    // }
    else if (
      (teamDetail?.pendingMembers?.employees?.length > 0 ||
        teamDetail?.pendingMembers?.admins?.length > 0) &&
      activeTab === "Pending"
    ) {
      const combinedPendingMembers = [
        ...(teamDetail?.pendingMembers?.employees || []),
        ...(teamDetail?.pendingMembers?.admins || []),
      ];
      totalPagesCount = Math.ceil(combinedPendingMembers.length / itemsPerPage);
      setTotalPages(totalPagesCount);
      teamMembers = combinedPendingMembers.slice(
        indexOfFirstEmployee,
        indexOfLastEmployee
      );
      setTeamMember(teamMembers);
    } else if (
      teamDetail?.upcomingMembers?.employees?.length > 0 &&
      activeTab === "Upcoming"
    ) {
      totalPagesCount = Math.ceil(
        teamDetail?.upcomingMembers?.employees?.length / itemsPerPage
      );
      setTotalPages(totalPagesCount);
      teamMembers = teamDetail?.upcomingMembers?.employees?.slice(
        indexOfFirstEmployee,
        indexOfLastEmployee
      );
      setTeamMember(teamMembers);
    } else if (
      teamDetail?.completedMembers?.employees?.length > 0 &&
      activeTab === "Completed"
    ) {
      totalPagesCount = Math.ceil(
        teamDetail?.completedMembers?.employees?.length / itemsPerPage
      );
      setTotalPages(totalPagesCount);
      teamMembers = teamDetail?.completedMembers?.employees?.slice(
        indexOfFirstEmployee,
        indexOfLastEmployee
      );
      setTeamMember(teamMembers);
    }
  }, [teamId, currentPage, teamDetail, setSelectedTeam, activeTab]);

  useEffect(() => {
    setCurrentPage(1);
  }, [teamId, teamDetail, setSelectedTeam, activeTab]);

  useEffect(() => {
    if (teamId) {
      getTeamDetails(teamId);
    }
    setUpdateTeamName(teamName);
    setOriginalTeamName(teamName);
  }, [teamId, teamName, setSelectedTeam]);

  const onCloseUpdateModal = () => {
    setIsNameEditable(false);
    setShowProcessModal(false);
    setShowSequenceModal(false);
    setShowModuleModal(false);
    setUpdateTeamName(teamName);
  };
  const handleTeamsModule = (event) => {
    setShowModuleModal(true);
    setShowModuleState(event);
  };

  // Function to handle "Next" button click
  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  // Function to handle "Previous" button click
  const handlePrevClick = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleDeleteClick = () => {
    if (teamDetail?.headerDetails?.imgCount > 0) {
      ToasterAlertError("Team can not be deleted as it has users available.");
    } else {
      setDeleteModal(true);
    }
  };
  const handleCancelEdit = () => {
    setUpdateTeamName(teamName); // Reset the name back to the original
    setIsNameEdit(false); // Exit the edit mode
  };
  return (
    <>
      {/* {!teamDetail && <Loader />} */}
      {teamDetail && (
        <div className="manageTeamsCard d-flex flex-column flex-grow-1">
          <div className="manageTeamsCardTop pt-4">
            <h2 className="d-flex justify-content-start align-item-center">
              {isNameEdit && (
                <div className="">
                  <input
                    className="inputInlineEdit"
                    value={updateTeamName}
                    onChange={(event) => {
                      setUpdateTeamName(event.target.value);
                    }}
                  />
                </div>
              )}
              {isNameEdit === false && (
                <>
                  <span>{updateTeamName}</span>
                  <span className="fw-normal">
                    ({teamDetail?.headerDetails?.imgCount})
                  </span>

                  <Link onClick={() => setIsNameEdit(true)} className="ms-3">
                    <IconEdit2 />
                  </Link>
                </>
              )}
              {isNameEdit && (
                <div>
                  {" "}
                  <button
                    onClick={() => {
                      handleNameUpdate();
                      setIsNameEdit(false);
                    }}
                    // disabled={updateTeamName?.trim() === ""  ? true : false}
                    disabled={
                      updateTeamName?.trim() === "" ||
                      updateTeamName === originalTeamName
                    }
                    className={`ms-3 pe-1 ${
                      updateTeamName?.trim() === "" ||
                      updateTeamName === originalTeamName
                        ? "opacity-50"
                        : ""
                    }`}
                  >
                    <TickGreen />
                  </button>
                  <Link onClick={handleCancelEdit} className="ms-2">
                    <CrossRed />
                  </Link>
                </div>
              )}
            </h2>
            {/* {isNameEditable && (
              <>
                <label htmlFor="teamName">
                  Team Name
                </label>
                <div class="d-flex p-2">
                <div>
                <input
                  type="text"
                  placeholder="Enter team name..."
                  value={updateTeamName}
                  onChange={(event) => {
                    setUpdateTeamName(event.target.value);
                  }}
                  onBlur={() => handleNameUpdate()}
                />
              </>
            )} */}
            <p className="h6 mt-2 mb-0 text-gray-300">
              Created on{" "}
              <span className="text-gray-100">
                {getFormatDate(teamDetail?.headerDetails.createdDate)}
                {/* <DateTimeConverter utcDateTime={teamDetail?.headerDetails.createdDate} /> */}
              </span>{" "}
              {getFormatDate(teamDetail?.headerDetails.modifiedDate) && (
                <>
                  | Last edited on{" "}
                  <span className="text-gray-100">
                    {" "}
                    {getFormatDate(teamDetail?.headerDetails.modifiedDate)}
                    {/* <DateTimeConverter utcDateTime={teamDetail?.headerDetails.modifiedDate} /> */}
                  </span>{" "}
                </>
              )}
              | Created by{" "}
              <span className="text-primary-400">
                {teamDetail?.headerDetails.createdBy}
              </span>
            </p>
            <button
              // onClick={() => setDeleteModal(true)}
              onClick={handleDeleteClick}
              className="h6 d-flex gap-2 align-items-center manageTeamsCardDelete text-primary-200"
            >
              <IconDelete2 />{" "}
              <span style={{ marginBottom: "-0.25rem" }}>Delete</span>
            </button>
            <div className="mt-4">
              <div className="d-flex gap-5">
                <div>
                  <div className="h6 text-gray-300 mb-3">Members</div>

                  {/* <div className="d-flex">
                    <div className="headImg moduleImg">
                      <img src={OwnerImg} alt="OwnerImg" />
                    </div>
                    <div className="headImg moduleImg">
                      <img src={OwnerImg} alt="OwnerImg" />
                    </div>
                    <div className="headImg moduleImg">
                      <img src={OwnerImg} alt="OwnerImg" />
                    </div>
                    <div className="headImg moduleImg imgCount">
                      <div className="text-xs total">
                        {teamDetail?.headerDetails.imgCount > 3 ? "+" : null}
                        {teamDetail?.headerDetails.imgCount}
                      </div>
                    </div>
                  </div> */}

                  <div className="d-flex">
                    {teamDetail?.headerDetails?.imgCount === 1 ? (
                      <div className="headImg moduleImg">
                        {/* <img src={OwnerImg} alt="" /> */}
                        {teamDetail?.allMembers[0].img ? (
                          <UserImage imgKey={teamDetail?.allMembers[0].img} />
                        ) : (
                          <img
                            src={getInitialsInName(
                              teamDetail?.allMembers[0].name ?? "N A",
                              36
                            )}
                            alt={teamDetail?.allMembers[0].name}
                          />
                        )}
                      </div>
                    ) : teamDetail?.headerDetails?.imgCount === 2 ? (
                      <>
                        <div className="headImg moduleImg">
                          {/* <img src={OwnerImg} alt="" /> */}
                          {teamDetail?.allMembers[0].img ? (
                            <UserImage imgKey={teamDetail?.allMembers[0].img} />
                          ) : (
                            <img
                              src={getInitialsInName(
                                teamDetail?.allMembers[0].name ?? "N A",
                                24
                              )}
                              alt={teamDetail?.allMembers[0].name}
                            />
                          )}
                        </div>
                        <div className="headImg moduleImg">
                          {/* <img src={OwnerImg} alt="" /> */}
                          {teamDetail?.allMembers[1].img ? (
                            <UserImage imgKey={teamDetail?.allMembers[1].img} />
                          ) : (
                            <img
                              src={getInitialsInName(
                                teamDetail?.allMembers[1].name ?? "N A",
                                24
                              )}
                              alt={teamDetail?.allMembers[1].name}
                            />
                          )}
                        </div>
                      </>
                    ) : teamDetail?.headerDetails?.imgCount > 2 ? (
                      <>
                        <div className="headImg moduleImg">
                          {/* <img src={OwnerImg} alt="" /> */}
                          {teamDetail?.allMembers[0].img ? (
                            <UserImage imgKey={teamDetail?.allMembers[0].img} />
                          ) : (
                            <img
                              src={getInitialsInName(
                                teamDetail?.allMembers[0].name ?? "N A",
                                24
                              )}
                              alt={teamDetail?.allMembers[0].name}
                            />
                          )}
                        </div>
                        <div className="headImg moduleImg">
                          {/* <img src={OwnerImg} alt="" /> */}
                          {teamDetail?.allMembers[1].img ? (
                            <UserImage imgKey={teamDetail?.allMembers[1].img} />
                          ) : (
                            <img
                              src={getInitialsInName(
                                teamDetail?.allMembers[1].name ?? "N A",
                                24
                              )}
                              alt={teamDetail?.allMembers[1].name}
                            />
                          )}
                        </div>
                      </>
                    ) : null}
                    {/* {teamDetail?.headerDetails?.imgCount ? (
                      <div className="headImg moduleImg imgCount">
                        <div className="text-xs total">
                          {teamDetail?.headerDetails?.imgCount > 2
                            ? `${"+"} ${teamDetail.headerDetails?.imgCount - 2}`
                            : +teamDetail.headerDetails?.imgCount}
                        </div>
                      </div>
                    ) : (
                      <div className="headImg moduleImg imgCount">
                        <div className="text-xs total">0</div>
                      </div>
                    )} */}
                    {teamDetail?.headerDetails?.imgCount > 2 ? (
                      <div className="headImg moduleImg imgCount">
                        <div className="text-xs total">
                          {`+ ${teamDetail.headerDetails?.imgCount - 2}`}
                        </div>
                      </div>
                    ) : teamDetail?.headerDetails?.imgCount === 0 ? (
                      <div className="headImg moduleImg imgCount">
                        <div className="text-xs total">0</div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div>
                  <div className="h6 text-gray-300 mb-3">
                    Average Onboarding Time
                  </div>
                  <div className="pt-2">
                    <h3 className="font-medium text-center">
                      {/* {teamDetail?.headerDetails.avgOnBorading.toFixed(1)} days */}
                      {teamDetail?.headerDetails.avgOnBorading === 0
                        ? "0 days"
                        : `${teamDetail?.headerDetails.avgOnBorading.toFixed(
                            1
                          )} days`}
                    </h3>
                  </div>
                </div>

                <div className="border-start"></div>
                <div>
                  <div className="h6 text-gray-300 mb-2">Processes</div>
                  <div className="d-flex justify-content-center pt-2">
                    {/* <Button
                      variant=""
                      className="d-flex border-0 align-items-center py-2 px-3"
                      onClick={() => handleTeamsModule("Processes")}
                    >
                      <h3 className="font-medium text-center">
                        {teamDetail?.headerDetails.processes}
                      </h3>
                    </Button> */}
                    <Link
                      to={{
                        pathname: `/accountsetting/details`,
                        state: {
                          operationType: "Processes",
                          propsData: { teamDetail: teamDetail, teamId: teamId },
                        },
                      }}
                      className="d-flex border-0 align-items-center py-2 px-3 text-gray-100"
                    >
                      <h3 className="font-medium text-center">
                        {teamDetail?.headerDetails.processes}
                      </h3>
                    </Link>
                  </div>
                </div>
                <div>
                  <div className="h6 text-gray-300 mb-2">Sequences</div>
                  <div className="d-flex justify-content-center pt-2">
                    {/* <Button
                      variant=""
                      className="d-flex border-0 align-items-center py-2 px-3"
                      // onClick={() => setShowSequenceModal(true)}
                      onClick={() => handleTeamsModule("Sequences")}
                    >
                      <h3 className="font-medium text-center">
                        {teamDetail?.headerDetails.sequences}
                      </h3>
                    </Button> */}
                    <Link
                      to={{
                        pathname: `/accountsetting/details`,
                        state: {
                          operationType: "Sequences",
                          propsData: { teamDetail: teamDetail, teamId: teamId },
                        },
                      }}
                      className="d-flex border-0 align-items-center py-2 px-3 text-gray-100"
                    >
                      <h3 className="font-medium text-center">
                        {teamDetail?.headerDetails.sequences}
                      </h3>
                    </Link>
                  </div>
                </div>
                <div>
                  <div className="h6 text-gray-300 mb-2">Modules</div>
                  <div className="d-flex justify-content-center pt-2">
                    {/* <Button
                      variant=""
                      className="d-flex border-0 align-items-center py-2 px-3"
                      // onClick={() => setShowModuleModal(true)}
                      onClick={() => handleTeamsModule("Modules")}
                    >
                      <h3 className="font-medium text-center">
                        {teamDetail?.headerDetails.modules}
                      </h3>
                    </Button> */}
                    <Link
                      to={{
                        pathname: `/accountsetting/details`,
                        state: {
                          operationType: "Modules",
                          propsData: { teamDetail: teamDetail, teamId: teamId },
                        },
                      }}
                      className="d-flex border-0 align-items-center py-2 px-3 text-gray-100"
                    >
                      <h3 className="font-medium text-center">
                        {teamDetail?.headerDetails.modules}
                      </h3>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="manageTeamsCardBody flex-grow-1 overflow-auto">
            <Row>
              <Col sm={12}>
                <b>Team</b>
                <div className="mt-2 pt-1 navTeam">
                  <TeamsNav
                    teamMember={teamDetail}
                    setActiveTab={setActiveTab}
                    activeTab={activeTab}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={8}>
                <div className="manageTeamsCardBodyContent rounded-6 borderAll">
                  <div className="d-flex justify-content-between align-items-center pe-4 mb-2 new-pagination">
                    <div>
                      {/* <h6 className="font-medium mb-4">Employees</h6> */}
                    </div>
                    <div className="d-flex justify-content-end align-items-center text-gray-1200 h6 font-normal">
                      Page{" "}
                      <span className="ms-1 me-1 text-gray-100 font-bold text-size">
                        {totalPages > 0 ? currentPage : 0}-{totalPages}
                      </span>
                      <div className="btnArrow ms-2">
                        <Button
                          variant="white p-1"
                          onClick={handlePrevClick}
                          disabled={currentPage === 1}
                        >
                          <IconleftArrow />
                        </Button>
                        <Button
                          variant="white p-1"
                          className="ms-3"
                          onClick={handleNextClick}
                          disabled={
                            totalPages === 0 ? true : currentPage === totalPages
                          }
                        >
                          <IconrightArrow />
                        </Button>
                      </div>
                    </div>
                  </div>
                  {loading ? (
                    <div className="h-100 w-100"><Loader type="activity" /></div>
                  ) : activeTab === "Currently Onboarding" ? (
                    <Onboarding
                      actionActivity={actionActivity}
                      teamMember={teamMember}
                      setUserData={setUserData}
                    />
                  ) : activeTab === "Pending" ? (
                    <Onboarding
                      actionActivity={actionActivity}
                      teamMember={teamMember}
                      setUserData={setUserData}
                    />
                  ) : activeTab === "Upcoming" ? (
                    <Onboarding
                      actionActivity={actionActivity}
                      teamMember={teamMember}
                      setUserData={setUserData}
                    />
                  ) : activeTab === "Completed" ? (
                    <Onboarding
                      actionActivity={actionActivity}
                      teamMember={teamMember}
                      setUserData={setUserData}
                    />
                  ) : null}
                </div>
              </Col>
              <Col sm={4}>
                <div className="manageTeamsCardBodyContent rounded-6 borderAll">
                  <h6 className="font-medium">Admin Team</h6>
                  <div className="mt-4">
                    {activeTab === "Currently Onboarding" ? (
                      <AdminTeam
                        actionActivity={actionActivity}
                        teamMember={teamDetail?.currentMembers?.admins}
                        setUserData={setUserData}
                      />
                    ) : activeTab === "Pending" ? (
                      <AdminTeam
                        actionActivity={actionActivity}
                        teamMember={teamDetail?.pendingMembers?.admins}
                        setUserData={setUserData}
                      />
                    ) : activeTab === "Upcoming" ? (
                      <AdminTeam
                        actionActivity={actionActivity}
                        teamMember={teamDetail?.upcomingMembers?.admins}
                        setUserData={setUserData}
                      />
                    ) : activeTab === "Completed" ? (
                      <AdminTeam
                        actionActivity={actionActivity}
                        teamMember={teamDetail?.completedMembers?.admins}
                        setUserData={setUserData}
                      />
                    ) : null}
                  </div>
                </div>
                {/* <div className="manageTeamsAccordion">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Processes Allocated33</Accordion.Header>
                      <Accordion.Body>
                        <ul className="text-sm text-gray-200">
                          <li>
                            <span>UI Design Tool</span>
                            <span className="text-md text-gray-300">
                              14 Jun
                            </span>
                          </li>
                          <li>
                            <span>Introduction to Jira 1</span>
                            <span className="text-md text-gray-300">
                              23 Apr
                            </span>
                          </li>
                          <li>
                            <span>UX Design Tool</span>
                            <span className="text-md text-gray-300">
                              11 Apr
                            </span>
                          </li>
                          <li>
                            <span>Understanding Accounts</span>
                            <span className="text-md text-gray-300">9 Apr</span>
                          </li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Sequences Allocated</Accordion.Header>
                      <Accordion.Body>
                        <ul className="text-sm text-gray-200">
                          <li>
                            <span>UI Design Tool</span>
                            <span className="text-md text-gray-300">
                              14 Jun
                            </span>
                          </li>
                          <li>
                            <span>Introduction to Jira 1</span>
                            <span className="text-md text-gray-300">
                              23 Apr
                            </span>
                          </li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>Modules Allocated</Accordion.Header>
                      <Accordion.Body>
                        <ul className="text-sm text-gray-200">
                          <li>
                            <span>UI Design Tool</span>
                            <span className="text-md text-gray-300">
                              14 Jun
                            </span>
                          </li>
                          <li>
                            <span>Introduction to Jira 1</span>
                            <span className="text-md text-gray-300">
                              23 Apr
                            </span>
                          </li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div> */}
              </Col>
            </Row>
          </div>
          {/* <div className="d-flex flex-column flex-grow-1 border-top bg-base-100 overflow-auto py-4 position-relative">
            <div className="d-flex justify-content-between w-100">
              <div>
                <h5>Team Members</h5>
                <h6 className="text-sm mt-4">
                  Employees <span className="font-medium">(1594)</span>
                </h6>
              </div>
              <div className="text-end">
                <button>
                  <FilterIcon2 />
                </button>
                <div className="position-absolute teamDetailsOpenFilter d-flex flex-column flex-grow-1">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <span className="text-md text-gray-1200 font-bold">
                        FILTERS
                      </span>
                      <span className="text-gray-400 text-md">|</span>
                      <button className="text-primary-100 text-md">
                        Clear all
                      </button>
                    </div>
                    <button>
                      <IconCross />
                    </button>
                  </div>
                  <div className="pt-2">
                    <Accordion className="filtersAccordian mt-3">
                      <Accordion.Item eventKey="1" className="mb-3">
                        <Accordion.Header className="mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="text-md font-medium text-gray-100 d-flex gap-2 align-items-center">
                              <IconSort />
                              <span className="head">Sort by</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="ps-1">
                            <div className="text-md text-gray-200 pb-1 mb-2">
                              <label className="checkBox">
                                <input value="Select_All" type="checkbox" />
                                <span className="checkBoxCheck"></span>
                                <span className="">Status</span>
                              </label>
                            </div>
                            <div className="text-md text-gray-200 pb-1 mb-2">
                              <label className="checkBox">
                                <input value="Select_All" type="checkbox" />
                                <span className="checkBoxCheck"></span>
                                <span className="">Role</span>
                              </label>
                            </div>
                            <div className="text-md text-gray-200 pb-1 mb-2">
                              <label className="checkBox">
                                <input value="Select_All" type="checkbox" />
                                <span className="checkBoxCheck"></span>
                                <span className="">Name</span>
                              </label>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="2" className="mb-3">
                        <Accordion.Header className="mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="text-md font-medium text-gray-100 d-flex gap-2 align-items-center">
                              <IconStatus />
                              <span className="head">Status</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="ps-1">
                            <div className="text-md text-gray-200 pb-1 mb-2">
                              <label className="checkBox">
                                <input value="Select_All" type="checkbox" />
                                <span className="checkBoxCheck"></span>
                                <span className="">Pending</span>
                              </label>
                            </div>
                            <div className="text-md text-gray-200 pb-1 mb-2">
                              <label className="checkBox">
                                <input value="Select_All" type="checkbox" />
                                <span className="checkBoxCheck"></span>
                                <span className="">Upcoming</span>
                              </label>
                            </div>
                            <div className="text-md text-gray-200 pb-1 mb-2">
                              <label className="checkBox">
                                <input value="Select_All" type="checkbox" />
                                <span className="checkBoxCheck"></span>
                                <span className="">Currently Onboarding</span>
                              </label>
                            </div>
                            <div className="text-md text-gray-200 pb-1 mb-2">
                              <label className="checkBox">
                                <input value="Select_All" type="checkbox" />
                                <span className="checkBoxCheck"></span>
                                <span className="">Completed</span>
                              </label>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="3" className="mb-3">
                        <Accordion.Header className="mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="text-md font-medium text-gray-100 d-flex gap-2 align-items-center">
                              <IconError />
                              <span className="head">Role</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="ps-1">
                            <div className="text-md text-gray-200 pb-1 mb-2">
                              <label className="checkBox">
                                <input value="Select_All" type="checkbox" />
                                <span className="checkBoxCheck"></span>
                                <span className="">Admin</span>
                              </label>
                            </div>
                            <div className="text-md text-gray-200 pb-1 mb-2">
                              <label className="checkBox">
                                <input value="Select_All" type="checkbox" />
                                <span className="checkBoxCheck"></span>
                                <span className="">Employee</span>
                              </label>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                  <div className="text-start mt-auto">
                    <button className="btn-secondary btn-sm px-4">Apply</button>
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-center text-gray-1200 h6 font-normal mt-4">
                  Page{" "}
                  <span className="ms-1 me-1 text-gray-100 font-bold text-size">
                    {totalPages > 0 ? currentPage : 0}-{totalPages}
                  </span>
                  <div className="btnArrow ms-2">
                    <Button
                      variant="white p-1"
                      onClick={handlePrevClick}
                      disabled={currentPage === 1}
                    >
                      <IconleftArrow />
                    </Button>
                    <Button
                      variant="white p-1"
                      className="ms-3"
                      onClick={handleNextClick}
                      disabled={
                        totalPages === 0 ? true : currentPage === totalPages
                      }
                    >
                      <IconrightArrow />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-grow-1 overflow-auto w-100">
              <table className="teamDeatilsTable">
                <tbody>
                  <tr>
                    <td>
                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <div className="headImg moduleImg">
                          <img src={OwnerImg} alt="" />
                        </div>
                        <p className="mb-0 text-md font-medium ps-1">
                          John Smith
                        </p>
                      </div>
                    </td>
                    <td>Pending</td>
                    <td>
                      <div className="d-flex justify-content-center align-items-center gap-4">
                        <div
                          className="progress tableProgress bg-gray-500"
                          style={{ height: "6px", width: "216px" }}
                        >
                          <div
                            className="progress-bar bg-secondary-300"
                            role="progressbar"
                            style={{ width: "40%" }}
                          ></div>
                        </div>
                        <div>12/15</div>
                      </div>
                    </td>
                    <td>Admin</td>
                  </tr>
                  <tr>
                    <td>
                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <div className="headImg moduleImg">
                          <img src={OwnerImg} alt="" />
                        </div>
                        <p className="mb-0 text-md font-medium ps-1">
                          John Smith
                        </p>
                      </div>
                    </td>
                    <td>Pending</td>
                    <td>
                      <div className="d-flex justify-content-center align-items-center gap-4">
                        <div
                          className="progress tableProgress bg-gray-500"
                          style={{ height: "6px", width: "216px" }}
                        >
                          <div
                            className="progress-bar bg-secondary-300"
                            role="progressbar"
                            style={{ width: "40%" }}
                          ></div>
                        </div>
                        <div>12/15</div>
                      </div>
                    </td>
                    <td>Admin</td>
                  </tr>
                  <tr>
                    <td>
                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <div className="headImg moduleImg">
                          <img src={OwnerImg} alt="" />
                        </div>
                        <p className="mb-0 text-md font-medium ps-1">
                          John Smith
                        </p>
                      </div>
                    </td>
                    <td>Pending</td>
                    <td>
                      <div className="d-flex justify-content-center align-items-center gap-4">
                        <div
                          className="progress tableProgress bg-gray-500"
                          style={{ height: "6px", width: "216px" }}
                        >
                          <div
                            className="progress-bar bg-secondary-300"
                            role="progressbar"
                            style={{ width: "40%" }}
                          ></div>
                        </div>
                        <div>12/15</div>
                      </div>
                    </td>
                    <td>Admin</td>
                  </tr>
                  <tr>
                    <td>
                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <div className="headImg moduleImg">
                          <img src={OwnerImg} alt="" />
                        </div>
                        <p className="mb-0 text-md font-medium ps-1">
                          John Smith
                        </p>
                      </div>
                    </td>
                    <td>Pending</td>
                    <td>
                      <div className="d-flex justify-content-center align-items-center gap-4">
                        <div
                          className="progress tableProgress bg-gray-500"
                          style={{ height: "6px", width: "216px" }}
                        >
                          <div
                            className="progress-bar bg-secondary-300"
                            role="progressbar"
                            style={{ width: "40%" }}
                          ></div>
                        </div>
                        <div>12/15</div>
                      </div>
                    </td>
                    <td>Admin</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> */}
        </div>
      )}
      <Modal
        className="modalDialog"
        size="sm"
        centered
        // show={unassignModel || responsePopup?.show}
        show={deleteModal || responsePopup?.show}
      >
        {deleteModal && (
          <ModalDelete
            onCancel={setDeleteModal}
            onConfirm={onConfirm}
            requestType="Delete"
            // headerLable="Are you sure you want to delete this team? "
            headerLable="Delete Team? "
            chldLable="This action will delete the team permanently and cannot be undone."
            // chldLable="This action will remove all employees added to this team and cannot be undone."
          />
        )}

        {responsePopup?.show && (
          <ModalResponse data={responsePopup} onClose={onClose} />
        )}
      </Modal>

      <Modal className="modalDialog" size="sm" centered show={isNameEditable}>
        <Modal.Header></Modal.Header>
        <Modal.Body className="mb-3">
          <h2 className="mb-4 pb-2">Update team</h2>
          <>
            <label className="pb-2" htmlFor="teamName">
              Team name
              {<span style={{ color: "red" }}>*</span>}
            </label>
            <input
              type="text"
              placeholder="Enter team name..."
              value={updateTeamName}
              onChange={(event) => {
                setUpdateTeamName(event.target.value);
              }}
            />
            {/* {updateTeamName?.trim() === "" ? (
              <label className="errorValidation" style={{ color: "red" }}>
                Team name is required!
              </label>
            ) : null} */}
          </>
        </Modal.Body>
        <Modal.Footer className="justify-content-end btnFooter py-3 noShadow">
          <Button
            variant="white"
            className="m-0"
            onClick={() => onCloseUpdateModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="m-0"
            onClick={() => handleNameUpdate()}
            disabled={updateTeamName?.trim() === "" ? true : false}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <Modal className="come-from-modal right" centered show={showModuleModal}>
        <Modal.Header
          closeButton
          className="bg-base-100 ps-5"
          onClick={() => onCloseUpdateModal(false)}
        ></Modal.Header>
        <TeamsModule
          onClose={() => setShowModuleModal(false)}
          showModuleState={showModuleState}
          teamDetail={teamDetail}
          teamId={teamId}
        />
      </Modal> */}
    </>
  );
};

export default TeamDetails;
